import { Toast } from './Toast';
import { useToastDismiss, useToastList } from './useToast';
import styles from './ToastContainer.module.css';

export function ToastContainer() {
  const toasts = useToastList();
  const dismiss = useToastDismiss();

  return (
    <div
      className={styles.container}
      role="region"
      aria-live="polite"
      aria-label="התראות"
    >
      {toasts.map((item) => (
        <Toast key={item.id} item={item} onDismiss={dismiss} />
      ))}
    </div>
  );
}
